export const FADE_SIZE = '1.5rem';
